var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attendance-gallery-container"},[_c('attendance-gallery-filters',{attrs:{"loading":_vm.loading},on:{"filter-change":_vm.handleFilterChange}}),_c('attendance-gallery-grid',{attrs:{"attendances":_vm.resources,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }